<template>
	<div
		class="w-full md:w-1/3 p-6 bg-green-500 text-green-100 flex flex-col justify-center"
	>
		<div v-if="locale == 'de'">
			<h3 class="py-4 text-2xl font-medium">
				cropspot<br />Die Plattformlösung für digitale Wertschöpfung im
				Agrarhandel:
			</h3>

			<ul class="mb-4">
				<li class="border-t border-green-300 py-4">
					Zugang zu Marktpreisen und Informationen
				</li>
				<li class="border-t border-green-300 py-4">
					Finden Sie Käufer und Verkäufer in Ihrer Region
				</li>
				<li class="border-t border-green-300 py-4">
					Profitieren Sie von Markt- und Preistransparenz
				</li>
				<li class="border-t border-green-300 py-4">
					Zeit sparen und Geld verdienen
				</li>
			</ul>
		</div>
		<div v-else>
			<h3 class="py-4 text-2xl font-medium">
				Why you should test cropspot now:
			</h3>

			<ul class="mb-4">
				<li class="border-t border-green-300 py-4">
					Access market prices and information
				</li>
				<li class="border-t border-green-300 py-4">
					Find buyers and sellers in your Region
				</li>
				<li class="border-t border-green-300 py-4">
					Benefit from market and price transparancy
				</li>
				<li class="border-t border-green-300 py-4">Save time and earn money</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {};
</script>
